import Record from './Record'

export default class CompanyTag extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new CompanyTag({
				id: null,
				name: ''
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/company_tag/${id}`)
			return new CompanyTag(data)
		}
	}

	static async delete (id) {
		console.log('id: ' + id)
		await Anvil.REST.delete(`/company_tag/${id}`)
	}

	async commit () {
		if (this._data.id == null) {
			// Insert
			const res = await Anvil.REST.post(`/company_tag`, this._data)
			this._data.id = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/company_tag/${this._data.id}`, this._data)
		}
	}
}
